module.exports = __webpack_public_path__ + "static/img/badge-landing-rate-active.53e7f5d.svg";